import { TFunction } from 'i18next';
import * as yup from 'yup';

export const validationChangeEmailSchema = (
  t: TFunction<'translation', undefined>,
) =>
  yup.object({
    email: yup
      .string()
      .email(t('userAuth.validationErrors.invalidEmail'))
      .matches(
        /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
        t('userAuth.validationErrors.invalidEmailWithoutDomain'),
      )
      .test(
        'forbidden-domains',
        t('userAuth.validationErrors.forbiddenEmailDomain'),
        (value) => {
          if (!value) return true;
          const forbiddenDomains = ['ru', 'by'];
          const domain: string = value?.split('.').pop() || '';
          return !forbiddenDomains.includes(domain);
        },
      )
      .required(t('userAuth.validationErrors.required')),
  }) as yup.ObjectSchema<{ email: string }>;
